import BaseStore from '../../BaseStore';
import TicketReasonModel from '../../../models/Maintenance/Ticket/TicketReasonModel';

class TicketReasonStore extends BaseStore {
  constructor(transportLayer) {
    super(TicketReasonModel, transportLayer);
  }
}

export default TicketReasonStore;



// WEBPACK FOOTER //
// ./src/stores/Maintenance/Ticket/TicketReasonStore.js